import {ReactElement} from 'react'
import {Route, Switch, withRouter, Redirect, RouteComponentProps} from 'react-router-dom'
import {config} from '../../../config'
import ForexAccountOverview from './ForexAccountOverview'
import ForexAccountSettings from './ForexAccountSettings'
import ForexAccountDownloadTrader from './ForexAccountDownloadTrader'
import Plan from './Plan'
import CopyTrading from './CopyTrading'
import {BrokereeProviderStats} from './scenes/BrokereeProviderStats'
import TradingCompetitions from '../TradingCompetitions'
import ProviderStats from './ProviderStats'
import {BrokereeCopyTradingOffer, Account, Client} from './types'

type ForexRoutesProps = {
  client: Client
  account: Account
  canBeBrokereeCopyTradingFollower: boolean
  currentOfferSubscription: BrokereeCopyTradingOffer | null
  brokereeCopyTradingOffers: BrokereeCopyTradingOffer[]
  brokereeCopyTradingOffersLoading: boolean
  showBrokereeProviderStats: boolean
  hasAccessToBrokereeAdvancedSettings: boolean
  onSubscriptionUpdated: () => void
  onBrokereeProviderUpdated: () => void
  onBrokereeOffersRefetch: () => void
} & RouteComponentProps

const ForexRoutes = (props: ForexRoutesProps): ReactElement => {
  const {match: {path, url},
    client,
    account,
    currentOfferSubscription,
    brokereeCopyTradingOffers,
    brokereeCopyTradingOffersLoading,
    showBrokereeProviderStats,
    canBeBrokereeCopyTradingFollower,
    hasAccessToBrokereeAdvancedSettings,
    onSubscriptionUpdated,
    onBrokereeProviderUpdated,
    onBrokereeOffersRefetch
  } = props

  const {showTab} = config
  const showDepositTab = showTab?.deposit ?? true
  const isBrokereeAutoLoginShown = currentOfferSubscription != null && !currentOfferSubscription.isUnsubscribePending && hasAccessToBrokereeAdvancedSettings
  const defaultTransactionPath = showDepositTab
    ? '/transactions/:accountId/deposit'
    : '/transactions/:accountId/withdrawal'

  return (
    <Switch>
      <Redirect from={`${path}/transactions/history`} to={{pathname: '/transactions/history', state: {prevPath: url}} }/>
      <Redirect from={`${path}/transactions`} to={{pathname: defaultTransactionPath, state: {prevPath: url}} }/>
      <Route
        path={`${path}/settings`}
        render={() => (
          <ForexAccountSettings
            isBrokereeAutoLoginShown={isBrokereeAutoLoginShown}
            onBrokereeProviderUpdated={onBrokereeProviderUpdated}
          />
        )}
      />
      <Route path={`${path}/plan`} component={Plan} />
      <Route path={`${path}/downloadTrader`} component={showTab ? ForexAccountOverview : ForexAccountDownloadTrader} />
      {/* <Redirect exact from={`${path}/tools/autochartist`} to={'/tools/autochartist'}/>
    <Redirect exact from={`${path}/tools/tradeCompanion`} to={'/tools/tradeCompanion'}/>
    <Redirect exact from={`${path}/tools/ebook`} to={'/tools/ebook'}/>
    <Redirect exact from={`${path}/tools`} to={'/tools'}/> */}
      <Route path={`${path}/copyTrading`} render={(routeProps) => <CopyTrading
          {...routeProps}
          canBeBrokereeCopyTradingFollower={canBeBrokereeCopyTradingFollower}
          brokereeCopyTradingOfferProps={{
            client,
            account,
            currentOfferSubscription,
            offers: brokereeCopyTradingOffers,
            isLoading: brokereeCopyTradingOffersLoading,
            onUpdated: onSubscriptionUpdated,
            onRefetch: onBrokereeOffersRefetch
          }}
        />}
      />
      <Route path={`${path}/tradingCompetitions`} component={TradingCompetitions} />
      <Route path={`${path}/providerStats`} component={ProviderStats} />
      <Route path={`${path}/brokereeProviderStats`} render={() => {
        if (!showBrokereeProviderStats) return <Redirect to="./" push={false} />
        return <BrokereeProviderStats account={account} />
      }} />
      <Route exact path={`${path}`} render={() => <ForexAccountOverview currentOfferSubscription={currentOfferSubscription} isBrokereeAutoLoginShown={isBrokereeAutoLoginShown}/>} />
    </Switch>
  )
}

export default withRouter(ForexRoutes)
